import {Component, ViewChild, AfterViewInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

import {AppService} from '@api';
import {SistemaService} from '@servicios/Sistema.Service';

import {AlertaEnum, DialogoEnum} from '@mensaje/Enumeraciones/MensajeEnumeraciones.enum';
import {MensajeService} from '@mensaje/Mensaje.Service';
import {RespuestaEstatusEnum} from '@enumeraciones/Enumeraciones.enum';

import {FiltrosComponent} from '@componentes/Filtros/Filtros.component';
import {FiltroModel} from '@componentes/Filtros/Filtro.model';
import {TipoFiltroEnum} from '@componentes/Filtros/Filtros.enum';

import {TipoDepartamento} from '@modelo/catalogo/TipoDepartamento.model';



@Component(
    {
        selector: 'tipodepartamento',
        templateUrl: './tipodepartamento.template.html',
        styleUrls: ['./tipodepartamento.component.scss']
    })

export class TipodepartamentoComponent implements AfterViewInit {
    dataTable!: Array<any>;

    public entidad: TipoDepartamento;

    public abierto!: boolean;
    public animacion!: string;
    public errorActivo!: boolean;

    @ViewChild(FiltrosComponent) filtrosComponent!: FiltrosComponent;
    uriApi: string

    constructor(private appService: AppService, private mensajeService: MensajeService, public sistemaService: SistemaService, public translate: TranslateService) {
        this.entidad = new TipoDepartamento();
        this.uriApi = "configuracionrh/tipodepartamento/buscar";
    }


    ngAfterViewInit() {
        this.GenerarFiltros()
    }

    GenerarFiltros() {
        let filtrosDisplay: Array<FiltroModel> = [];

        filtrosDisplay.push(
            new FiltroModel(
                {
                    TipoFiltro: TipoFiltroEnum.Input,
                    Titulo: 'Descripción',
                    Obligatorio: false,
                    MensajeError: "",
                    Propiedad: 'nombre'
                })
        );

        filtrosDisplay.push(
          new FiltroModel(
              {
                  TipoFiltro: TipoFiltroEnum.DropDown,
                  Titulo: 'Asociar nivel',
                  DisplayValor: 'nombre',
                  ValorName: 'valor',
                  Opciones: [{nombre: "Sí", valor: true}, {nombre: "No", valor: false}],
                  Propiedad: "asociarnivel",
                  Obligatorio: false,
                  Buscar: false
              })
      );

        filtrosDisplay.push(
            new FiltroModel(
                {
                    TipoFiltro: TipoFiltroEnum.DropDown,
                    Titulo: 'Activo',
                    DisplayValor: 'nombre',
                    ValorName: 'valor',
                    Opciones: [{nombre: "Sí", valor: true}, {nombre: "No", valor: false}],
                    Propiedad: "activo",
                    Obligatorio: false,
                    Buscar: false
                })
        );

        this.filtrosComponent.SetFiltros(filtrosDisplay, true);
    }

    SetDatos(data: any) {
        this.dataTable = data;
    }

    Editar(e: TipoDepartamento) {
        this.entidad = new TipoDepartamento(e);
        this.Modal();
    }

    Modal() {
        this.animacion = this.sistemaService.animacionAbirModal;
        this.abierto = true;
        this.errorActivo = false;
    }

    CerrarModal() {
        this.entidad = new TipoDepartamento();
        this.animacion = this.sistemaService.animacionCerrarModal;

        setTimeout(() => {
            this.abierto = false;
        }, 310);
    }

    Guardar() {
        this.errorActivo = true;

        if (!this.entidad.nombre || !this.entidad.nombre.trim()) {
            return this.mensajeService.Alerta(AlertaEnum.Warning, "Ingrese una descripción");
        }
        
        let data = new TipoDepartamento(this.entidad)
        this.appService.Post("configuracionrh/tipodepartamento", data).then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.mensajeService.Alerta(AlertaEnum.Success, res.message);
                this.CerrarModal();
                this.filtrosComponent.Consultar(this.filtrosComponent.filtros);
            }
        })
    }

    Eliminar(e: TipoDepartamento) {
        let opciones = this.sistemaService.GetOpcionesEliminar();
        this.mensajeService.Dialogo(DialogoEnum.aviso, '', '¿Estás seguro que quieres eliminar el registro? <br> Esta acción no se podra deshacer.', opciones).then(res => {
            if (res == 1) {
                this.appService.Delete("configuracionrh/tipodepartamento/" + e.tipodepartamentoid).then(res => {
                    if (res.status == RespuestaEstatusEnum.Success) {
                        this.mensajeService.Alerta(AlertaEnum.Success, res.message);
                        this.filtrosComponent.Consultar(this.filtrosComponent.filtros);
                    }
                })
            }
        })
    }

    setAsociarNivel(e: any) {
        if (e.asociarnivel) {
            return "Si";
        }
        else {
            return "No";
        }
    }

}
